import { gql } from 'apollo-boost'

export const query = gql`
  query ExcludedDates($inputs: ExcludedDatesInputs!) {
    excludedDates(inputs: $inputs)
  }
`
